<script>
import { mapActions } from 'vuex'
import TermoContainer from '../components/termo-container/termo-container.vue'

export default {

  components: {
    TermoContainer
  },

  data () {
    return {
      textoTermo: ''
    }
  },

  async created () {
    this.getTextoTermo()
  },

  methods: {
    ...mapActions({
      getTermoDeUso: 'usuario/getTermoDeUso'
    }),
    async getTextoTermo () {
      this.textoTermo = await this.getTermoDeUso()
    }
  }
}
</script>

<template>
  <termo-container
    v-if="textoTermo"
    :texto="textoTermo"
  />
</template>



// WEBPACK FOOTER //
// src/App/(authenticated)/termos/termo-de-uso/termo-de-uso.vue